module.exports = __webpack_public_path__ + "static/rafe-dickinson-fab187454808ee673284d0a9a989b8e2.png";